import {Component} from "react";
import React from "react";
import PropTypes from 'prop-types';

export default class SearchByFieldStep extends Component {

    constructor(props) {
        super(props);
        this.onMappedFieldValueChange = this.onMappedFieldValueChange.bind(this);
        this.onEnter = this.onEnter.bind(this);
    }

    onMappedFieldValueChange(e) {
        this.props.changePatientSearchValue(e.target.value)
    }

    onEnter(e) {
        if (e.key === 'Enter') {
            this.onMappedFieldValueChange(e);
            this.props.searchPatient()
        }
    }

    render () {
        const I18n = require('react-redux-i18n').I18n;
        return (
            <div>
                <div className="patient-lookup-lbl">
                    {I18n.t('Patient Lookup')}
                </div>
                <div className="bootstrap field">
                    <input type='text' className='form-control'
                           placeholder={I18n.t('Enter Your') + ' ' + this.props.mrnField}
                           value={this.props.searchValue}
                           style={{textAlign: 'center'}}
                           onKeyPress={this.onEnter}
                           onChange={this.onMappedFieldValueChange}/>
                </div>
                <div className="bootstrap field">
                    <button className="btn btn-primary search-btn" onClick={this.props.searchPatient}>{I18n.t('Search')}</button>
                </div>
            </div>
        );
    }
}

SearchByFieldStep.PropTypes = {
    mrnField: PropTypes.string.isRequired,
    searchValue: PropTypes.string,
    changePatientSearchValue: PropTypes.func,
    searchPatient: PropTypes.func
};